import { useMapEvents } from "react-leaflet";

// MapClickHandler Component to handle map click interactions
const MapClickHandler = ({ onClick }) => {
  useMapEvents({
    click: (event) => {
      onClick?.(event); // Pass the latlng of the click to the onClick function
    },
  });
  return null;
}

export default MapClickHandler;